import { Box } from "@repo/ui/core";
import { SectionDivider } from "@components/SectionDivider";

type Props = {
  number: string;
  title: string;
};

export function SectionDividerSlide({ number, title }: Props) {
  return (
    <Box w="100%" maw={1400}>
      <SectionDivider number={number} title={title} />
    </Box>
  );
}
